import type { Call as TelnyxCall } from '@telnyx/webrtc';
import type { CallState } from './types';
import { CallInfoParser } from './CallInfoParser';

export type CallStateChangeHandler = (state: CallState) => void;

export class CallStateMonitor {
  private poller: number | null = null;
  private lastState: CallState | null = null;
  private call: TelnyxCall | null = null;
  private readonly intervalMs: number;
  private readonly onChange: CallStateChangeHandler;

  constructor(onChange: CallStateChangeHandler, intervalMs = 400) {
    this.onChange = onChange;
    this.intervalMs = intervalMs;
  }

  start(call: TelnyxCall): void {
    this.stop();
    this.call = call;
    this.poller = window.setInterval(() => {
      const state = call.state as CallState | undefined;
      if (!state) return;
      this.processState(state);
    }, this.intervalMs);
  }

  externalStateUpdate(state: CallState): void {
    this.processState(state);
  }

  stop(): void {
    if (this.poller !== null) {
      clearInterval(this.poller);
      this.poller = null;
    }
    this.call = null;
    this.lastState = null;
  }

  private processState(state: CallState): void {
    if (!CallInfoParser.isValidState(state)) return;
    if (state === this.lastState) return;

    this.lastState = state;
    this.onChange(state);

    if (state === 'hangup' || state === 'destroy') {
      this.stop();
    }
  }
} 